import utils from './utils.js'

class Controller {
  constructor (player) {
    this.player = player

    this.initPlayButton()
    this.initPlayBar()
    this.initSeekButton()
    if (!utils.isMobile()) {
      this.initVolumeButton()
      // this.initSpeedButton()
    }
  }

  initPlayButton () {
    this.player.template.button.addEventListener('click', () => {
      this.player.toggle()
    })
  }

  initPlayBar () {
    const thumbMove = (e) => {
      let percentage = ((e.clientX || e.changedTouches[0].clientX) - this.player.template.barWrap.getBoundingClientRect().left) / this.player.template.barWrap.clientWidth
      percentage = Math.max(percentage, 0)
      percentage = Math.min(percentage, 1)
      this.player.bar.set('played', percentage, 'width')
      this.player.lrc && this.player.lrc.update(percentage * this.player.duration)
      this.player.template.ptime.innerHTML = utils.secondToTime(percentage * this.player.duration)
    }

    const thumbUp = (e) => {
      document.removeEventListener(utils.nameMap.dragEnd, thumbUp)
      document.removeEventListener(utils.nameMap.dragMove, thumbMove)
      let percentage = ((e.clientX || e.changedTouches[0].clientX) - this.player.template.barWrap.getBoundingClientRect().left) / this.player.template.barWrap.clientWidth
      percentage = Math.max(percentage, 0)
      percentage = Math.min(percentage, 1)
      this.player.bar.set('played', percentage, 'width')
      this.player.seek(percentage * this.player.duration)
      this.player.disableTimeupdate = false
    }

    this.player.template.barWrap.addEventListener(utils.nameMap.dragStart, () => {
      this.player.disableTimeupdate = true
      document.addEventListener(utils.nameMap.dragMove, thumbMove)
      document.addEventListener(utils.nameMap.dragEnd, thumbUp)
    })
  }

  initVolumeButton () {
    this.player.template.volumeWrap.style.display = 'flex'
    this.player.template.volumeButton.addEventListener('click', () => {
      if (this.player.audio.muted) {
        this.player.volume(this.player.audio.volume, true)
      } else {
        this.player.audio.muted = true
        this.player.switchVolumeIcon()
        this.player.bar.set('volume', 0, 'width')
      }
    })

    const thumbMove = (e) => {
      let percentage = ((e.clientX || e.changedTouches[0].clientX) - this.player.template.volumeBar.getBoundingClientRect().left) / this.player.template.volumeBar.clientWidth
      percentage = Math.max(percentage, 0)
      percentage = Math.min(percentage, 1)
      this.player.volume(percentage)
    }

    const thumbUp = (e) => {
      document.removeEventListener(utils.nameMap.dragEnd, thumbUp)
      document.removeEventListener(utils.nameMap.dragMove, thumbMove)
      let percentage = ((e.clientX || e.changedTouches[0].clientX) - this.player.template.volumeBar.getBoundingClientRect().left) / this.player.template.volumeBar.clientWidth
      percentage = Math.max(percentage, 0)
      percentage = Math.min(percentage, 1)
      this.player.volume(percentage)
    }

    this.player.template.volumeBarWrap.addEventListener(utils.nameMap.dragStart, () => {
      document.addEventListener(utils.nameMap.dragMove, thumbMove)
      document.addEventListener(utils.nameMap.dragEnd, thumbUp)
    })
  }

  initSeekButton () {
    this.player.template.seekForward.addEventListener('click', () => {
      this.player.seek(this.player.audio.currentTime + 15)
    })

    this.player.template.seekBackward.addEventListener('click', () => {
      this.player.seek(this.player.audio.currentTime - 15)
    })
  }

  initNodeList () {
    for (let i = 0; i < this.player.template.nodeList.length; i++) {
      let el = this.player.template.nodeList[i]
      let time = parseInt(el.dataset.time)
      if (!isNaN(time)) {
        time = Math.max(time, 0)
        time = Math.min(time, this.player.duration)
        el.addEventListener('click', () => {
          this.player.seek(time)
        })
        el.style.left = time / this.player.duration * 100 + '%'
        el.style.visibility = 'visible'
      }
    }
  }

  initSpeedButton () {
    this.player.template.speedWrap.style.display = 'block'
    for (let i = 0; i < this.player.template.speedList.length; i++) {
      let el = this.player.template.speedList[i]
      el.addEventListener('click', () => {
        this.player.speed(el.dataset.speed)
        this.player.template.speedButton.innerHTML = `${el.dataset.speed}X`
      })
    }
  }
}

export default Controller
